jQuery(document).ready(function($){

  var url = location.href;

  $('.productitem__badge--end-of-sales').prev('.productitem__badge--soldout').addClass('productitem__badge--disabled').detach();

  if(url.indexOf('/collections/products') !== -1){
    $('.subcollections-list__content .subcollections-grid__item:first-child').detach();
  }

  if(url.endsWith('chemical-aerosol') || url.endsWith('jig-tools') || url.endsWith('educational-training') || url.endsWith('original-board-production') || url.endsWith('universal-boards') || url.endsWith('board-accessories') || url.endsWith('conversion-adapter') || url.endsWith('help-home-electronics')){
    $('.productgrid--sidebar-group').eq(0).addClass('disnon');
  }else{
    $('.subcollections__container').addClass('disnon');
  }

  /*
  $('.subcollections__container').before('<p class="collection--notice">【不具合のお知らせ ※原因調査中】<br>各サブカテゴリーをクリックしても、現在、商品を絞り込むフィルターが機能していません。ご不便をおかけいたしますが、検索窓でのキーワード検索をご活用ください。</p>');
  */

  /*
  if(url.indexOf('%E3%82%B5%E3%83%96%E3%82%AB%E3%83%86%E3%82%B4%E3%83%AA%E3%83%BC_') !== -1 || url.indexOf('subcategory_') !== -1){
    $('.subcollections__container').addClass('disnon');
  }else{
    $('.productgrid--sidebar-group').eq(0).addClass('disnon');
  }
  */

  $('.productgrid--sidebar-group:not(:has(.filter-item:not(.filter-item--disabled)))').addClass('productgrid--sidebar-group--disabled').detach();

  $('.product-form--regular .variants-ui__option-values .variants-ui__option-value').on('click', function(){
    var index = $(this).index();
    $('.inventory-quantity').removeClass('selected');
    $('.inventory-quantity').eq(index).addClass('selected');
  });

  /*
  if(url.indexOf('/sds-') !== -1 || url.indexOf('/tds-') !== -1 || url.indexOf('/drawing-') !== -1 || url.indexOf('/manual-') !== -1 || url.indexOf('/sample-program-') !== -1 || url.indexOf('/rohs-guarantee-') !== -1){
    $('.product-description').prepend('<div id="attention-download" class="section"><p class="caution">【2023年5月16日（火） 不具合のお知らせ】ダウンロードに非常に時間がかかる事例が確認されています。お急ぎの場合には、お手数ですがお電話でご連絡をお願いいたします。</p><dl><dt>受付時間</dt><dd>8：30～17：20（土日祝日を除く）</dd></dl><dl><dt>TEL</dt><dd>03（3984）7791</dd></dl><p>ご迷惑をおかけしますが、何卒よろしくお願いいたします。</p></div>');
  }
  */

  $('.product-description .button-wrap li a').addClass('button-secondary');

  /*
  $('#attention-payment .caution').text('※資料をダウンロードしたい方は「カートに追加」して、「レジに進む」から注文を完了してください。料金は発生しません。');
  $('#description-how-to .how-to li').eq(1).replaceWith('<li>「レジに進む」ボタンから画面の指示に従い、「ご注文完了」まで手続きしてください。<br>※他の商品がカートに入っていなければ、当アイテムは無料ですのでお支払いは発生しません。</li>');
  $('#description-how-to .caution').after('<p class="caution">※各資料をダウンロードできるのは原則3回までとなっております。一度ダウンロードしたら、お手元に保存することを推奨いたします。</p><p class="caution">※本資料はダウンロードをしたお客様が個人的に閲覧することを目的としており、資料の一部、又は全部を当社の承諾なしでいかなる形でも転載、又は複製されることは固くお断りします。</p>');
  */

  $('#quick-quote-wrapper').before('<nav class="breadcrumbs-container quick-quote-breadcrumbs-container" aria-label="パンくずリスト"><a href="/">ホーム</a><span class="breadcrumbs-delimiter" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5"><path fill="currentColor" fill-rule="evenodd" d="M1.002.27L.29.982l3.712 3.712L7.714.982 7.002.27l-3 3z"></path></svg></span><a href="/cart">カート</a><span class="breadcrumbs-delimiter" aria-hidden="true"><svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5"><path fill="currentColor" fill-rule="evenodd" d="M1.002.27L.29.982l3.712 3.712L7.714.982 7.002.27l-3 3z"></path></svg></span><span>受注生産品の納期問い合わせ</span></nav>');
  $('#quick-quote-wrapper #onlyNonQuoteItems').replaceWith('<p id="onlyNonQuoteItems">お客様のカートには、注文可能なアイテムのみが入っています。<a class="quick-quote-cart--button" href="/cart">カート</a>へお戻りいただき、「レジに進む」から注文を完了してください。</p>');
  $('#quick-quote-wrapper .quote-form').prepend('<p class="quote-supplement-messages">納期確認する商品は上記の通りです。明細を変更する場合は<a class="quick-quote-cart--button" href="/cart">カート</a>へお戻りください。</p>');
  $('#quick-quote-wrapper .quote-required-message').append('<span class="quote-input-important">電話番号、法人名の項目も正確に入力していただくと、納期確認をスムーズに進めることができます。</span>');
  $('#quick-quote-wrapper .quote-input-group').eq(1).insertAfter('.quote-required-message');
  $('#quick-quote-wrapper #pnl-thank-you h2').after('<div class="quote-thank-you-messages"><p>お問い合わせ商品について納期を確認中です。2営業日以内に担当からメールで返信いたします。ご購入方法はその際にご案内いたしますので、今しばらくお待ちください。</p></div>');
  $('#quick-quote-wrapper #stillCartItems').replaceWith('<p id="stillCartItems">お客様のカートに、注文可能なアイテムが残っています。<a class="quick-quote-cart--button" href="/cart">カート</a>へお戻りいただき、「レジに進む」から注文を完了してください。</p>');
  $('#quick-quote-wrapper #pnl-thank-you').append('<p class="quote-cart-continue"><a class="cart-continue" href="/collections/products">ショッピングを続ける<svg class="icon-signpost-arrow" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.7272 5.6364L10.3636 1.27279L11.6364 0L17.2728 5.6364L11.6364 11.2728L10.3636 10L14.7272 5.6364Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.73645L16 4.73645L16 6.53645L-1.57361e-07 6.53645L0 4.73645Z" fill="currentColor"></path></svg></a></p>');
  $('#quick-quote-wrapper #cart-empty').html('<div class="cartitems-empty"><div class="cartitems-empty--inner"><p>お客様のカートには何も入っていません</p><a class="button-primary mdc-ripple-surface mdc-ripple-upgraded" href="/collections/products"><svg width="25" height="24" viewBox="0 0 25 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H1.33877H1.33883C1.61048 2.00005 2.00378 2.23945 2.10939 2.81599L2.10937 2.816L2.11046 2.82171L5.01743 18.1859C5.12011 18.7286 5.64325 19.0852 6.18591 18.9826C6.21078 18.9779 6.23526 18.9723 6.25933 18.9658C6.28646 18.968 6.31389 18.9692 6.34159 18.9692H18.8179H18.8181C19.0302 18.9691 19.2141 18.9765 19.4075 18.9842L19.4077 18.9842C19.5113 18.9884 19.6175 18.9926 19.7323 18.9959C20.0255 19.0043 20.3767 19.0061 20.7177 18.9406C21.08 18.871 21.4685 18.7189 21.8028 18.3961C22.1291 18.081 22.3266 17.6772 22.4479 17.2384C22.4569 17.2058 22.4642 17.1729 22.4699 17.1396L23.944 8.46865C24.2528 7.20993 23.2684 5.99987 21.9896 6H21.9894H4.74727L4.07666 2.45562L4.07608 2.4525C3.83133 1.12381 2.76159 8.49962e-05 1.33889 0H1.33883H1ZM5.12568 8L6.8227 16.9692H18.8178H18.8179C19.0686 16.9691 19.3257 16.9793 19.5406 16.9877L19.5413 16.9877C19.633 16.9913 19.7171 16.9947 19.7896 16.9967C20.0684 17.0047 20.2307 16.9976 20.3403 16.9766C20.3841 16.9681 20.4059 16.96 20.4151 16.9556C20.4247 16.9443 20.4639 16.8918 20.5077 16.7487L21.9794 8.09186C21.9842 8.06359 21.9902 8.03555 21.9974 8.0078C21.9941 8.00358 21.9908 8.00108 21.989 8H5.12568ZM20.416 16.9552C20.4195 16.9534 20.4208 16.9524 20.4205 16.9523C20.4204 16.9523 20.4199 16.9525 20.4191 16.953L20.416 16.9552ZM10.8666 22.4326C10.8666 23.2982 10.195 24 9.36658 24C8.53815 24 7.86658 23.2982 7.86658 22.4326C7.86658 21.567 8.53815 20.8653 9.36658 20.8653C10.195 20.8653 10.8666 21.567 10.8666 22.4326ZM18.0048 24C18.8332 24 19.5048 23.2982 19.5048 22.4326C19.5048 21.567 18.8332 20.8653 18.0048 20.8653C17.1763 20.8653 16.5048 21.567 16.5048 22.4326C16.5048 23.2982 17.1763 24 18.0048 24Z" fill="currentColor"></path></svg>ショッピングを続ける</a></div></div>');

  $('.nav-open').click(function(){
    $(this).toggleClass('active');
    $(this).next('.nav').slideToggle();
  });

  $('#tayori-form .submit').addClass('disabled');
  $('.handle-contact .contact-form-accept, #tayori-form .contact-form-accept').on('click', function(){
    if($(this).prop('checked')){
      $('.contact-form-button, #tayori-form .submit').removeClass('disabled');
    }else{
      $('.contact-form-button, #tayori-form .submit').addClass('disabled');
    }
  });

  $('.handle-contact .contact-message.message--success').nextAll('div[class^="form"]').detach();

  var frcp_profile_last_name = $('.frcp-app .frcp-profile__last-name .frcp-profile-block__content').text();
  var frcp_nav_name = $('.frcp-app .frcp-nav__title .frcp-nav__name .frcp-nav__last-name').text() + $('.frcp-app .frcp-nav__title .frcp-nav__name .frcp-nav__first-name').text();
  $('.frcp-app .frcp-nav__title .frcp-nav__name').text(frcp_nav_name + ' 様');
  /* $('.frcp-app .frcp-nav__title .frcp-nav__name').text(frcp_nav_name + ' 様').before('<div class="frcp-nav__name-caution">親しみを込めて</div>'); */

  /* 「アカウント ＞ 登録済み住所」ページで新規住所の登録時にデフォルトで国名に「日本」がセットされる（アプリ側でも対応してもらったためコメントアウト）
  $('.frcp-container').ready(function(){
    $('.frcp-container .frcp-address-form[action="/account/addresses"] #address_country').val('Japan');
  };
  */

  $('.frcp-wishlist-link-wrapper .frcp-wishlist-link-count').clone().appendTo('.frcp-wishlist-nav-link-li');
});

window.addEventListener('load', function() {
  if(!localStorage.getItem('disp-modal-cookie')){
    localStorage.setItem('disp-modal-cookie', 'on');
    var popup = document.getElementsByClassName('modal-cookie');
    popup[0].classList.add('js_active');
    popup[0].onclick = function(){
      popup[0].classList.remove('js_active');
    }
  }
}, false);

var filter_group = [], filter_group_disnon = [], query = '';
var url = location.href;

if(url.indexOf("/collections/products") !== -1){


  filter_group = [
    'サブカテゴリー', 
    'Subcategory'
  ];
//  filter_group_disnon = document.querySelectorAll('.filter-group[data-filter-group="サブカテゴリー"], .filter-group[data-filter-group="Subcategory"]');
}
if (document.documentElement.lang == "ja") {
  filter_group_add = [
    'Category', 
    'Subcategory', 
    'Sales Status', 
    'RoHS Directive', 
    'Material types', 
    'Double-sided / Single-sided', 
    'Pitch', 'Materials', 'Documents', 
    'Package before Conversion', 
    'Pitch after Conversion', 
    'Pitch before Conversion'
  ];
  Array.prototype.push.apply(filter_group, filter_group_add);
//  filter_group_disnon = document.querySelectorAll('.filter-group[data-filter-group="Category"], .filter-group[data-filter-group="Subcategory"], .filter-group[data-filter-group="Sales Status"], .filter-group[data-filter-group="RoHS Directive"], .filter-group[data-filter-group="Material types"], .filter-group[data-filter-group="Double-sided / Single-sided"], .filter-group[data-filter-group="Pitch"], .filter-group[data-filter-group="Materials"], .filter-group[data-filter-group="Package before Conversion"], .filter-group[data-filter-group="Pitch after Conversion"], .filter-group[data-filter-group="Pitch before Conversion"]');
}
if (document.documentElement.lang == "en") {
  filter_group_add = [
    'カテゴリー', 
    'サブカテゴリー', 
    '材質',
    'ピッチ',
    '資料',
    '変換前パッケージ',
    '変換前ピッチ',
    '受注方法',
    '配送方法'
  ];
  Array.prototype.push.apply(filter_group, filter_group_add);
//  filter_group_disnon = document.querySelectorAll('.filter-group[data-filter-group="サブカテゴリー"], .filter-group[data-filter-group="変換前ピッチ"]');
}
filter_group.forEach(function(item, index, array) {
  query += '.filter-group[data-filter-group="' + item + '"],'
});
query = query.slice( 0, -1 ) ;
filter_group_disnon = document.querySelectorAll(query);
filter_group_disnon.forEach(function(elem, index) {
  var filter_group_disnon_parent = elem.closest(".productgrid--sidebar-group");
  filter_group_disnon_parent.classList.add('disnon');
//  filter_group_disnon_parent.style.display ="none";
});

if ( url.indexOf('/problem-solving/') > -1) {
  document.body.classList.add('problem-solving');
}
if ( url.indexOf('/column/') > -1) {
  document.body.classList.add('tech-column');
}